const baseURL = process.env.REACT_APP_FLOW_ENDPOINT_URL
const contentURL = process.env.REACT_APP_CONTENT_ENDPOINT
export default {
  baseURL,
  quote: baseURL + 'quote/',
  ships: contentURL + 'ships/',
  brands: contentURL + 'brands/',
  countries: contentURL + 'countries/',
  cruise: baseURL + 'cruise',
  destinations: contentURL + 'destinations',
  rfp: baseURL + 'rfp',
  labelsData: contentURL + 'labels/eQuote',
  stateroomTypes: contentURL + 'stateroom-types/',
  calendar: baseURL + 'calendar/'
}
